import { isNumber } from '../helpers/numbers'
import moment from 'moment'

export class Validator {

    /**
     * Create a new Validator instance.
     */
    constructor() {
        this.getLang()
    }

    getLang() {
        axios.get('/lang?language=' + window.language + '&hash=' + window.app_hash + '&route=validation&only=1')
            .then(({data}) => {
                this.lang = data.validation
            })
    }

    /**
     * Validates the Form against the rule set.
     * @param {array} rules
     * @param {array} values
     */
    validate(rules, values) {
        let errors = {}
        this.data = values

        for (let field in rules) {
            if(field.includes('.')) {
                let split = field.split('.'),
                    parent = split[0],
                    child = isNumber(split[1]) ? split[2] : split[1]

                rules[field].forEach(rule => {
                    if(typeof values[parent] === 'undefined') {
                        errors[parent] = this.lang[parent] && this.lang[parent] ?  this.lang[parent] : rule
                    }
                    else {

                        if(! values[parent].isArray === 'undefined'){
                            values[parent].forEach((element, index) => {
                                let value = element[child],
                                result = this.callValidationMethod(rule, value)
                                if(! result) {
                                    errors[parent + '.' + index + '.' + child] = this.lang[parent] && this.lang[parent][child] ?  this.lang[parent][child] : rule
                                }
                            })
                        }
                        else{
                            let element = values[parent] 
                                            ? values[parent][child] 
                                            : null
                            let result = this.callValidationMethod(rule, element)
                            if(! result) {
                                errors[parent + '.' + child] = this.lang[parent] && this.lang[parent][child] ?  this.lang[parent][child] : rule
                            }
                        }

                    }
                })

                continue
            }

            rules[field].forEach(rule => {
                let value = values[field],
                    result = this.callValidationMethod(rule, value)

                if(! result) {
                    if(rule.includes(':')) {
                        rule = rule.split(':')[0]
                    }

                    errors[field] = this.getErrorMessage(field, rule)
                }
            })
        }

        return errors
    }

    /**
     * Calls the correct validation method for the field.
     */
    callValidationMethod(rule, value) {

        if(rule.includes(':')) {
            let ruleName = rule.split(':')[0],
                parameter = rule.split(':')[1],
                extra = rule.split(':')[2]

            if(parameter && parameter.includes(',')) {
                parameter = parameter.split(',')
            }

            return this[ruleName](value, parameter, extra)
        }

        return this[rule](value)
    }


    getErrorMessage(field, rule) {
        if(this.lang && this.lang.custom[field] && this.lang.custom[field][rule]) {
            return this.lang.custom[field][rule]
        }

        if(this.lang[field]) {
            return this.lang[field]
        }

        return this.lang[rule]
            ? this.lang[rule]
            : rule
    }

    empty(value) {
        return typeof value == 'undefined' || value === null || value === '' || value === false ||  Number.isNaN(value)
    }

    get_value(field){
        if(! field.includes('.')){
            return this.data[field]
        }

        let split = field.split('.'),
            parent = split[0],
            child = isNumber(split[1]) ? split[2] : split[1]

        return this.data[parent] 
            ? this.data[parent][child]
            : null
    }

    required(value) {
        if(Array.isArray(value)) {
            return value.length > 0
        }

        return ! this.empty(value)
    }

    required_if(value, field) {
        let otherValue = this.get_value(field),
            exists = Array.isArray(otherValue) ? otherValue.length > 0 : otherValue

        if(exists) {
            return this.required(value)
        }

        return true
    }

    required_without(value, field) {
        let otherValue = this.get_value(field),
            exists = Array.isArray(otherValue) ? otherValue.length > 0 : otherValue
        if (! exists) {
            return this.required(value)
        }

        return true
    }

    required_without_all(value, fields){
        let other_values = true
        if(Array.isArray(fields)){
            other_values = fields.reduce(
                ( acc , field) => {
                    let result = this.required_without( value, field ) || acc
                    return result
                },
                false
            )
        }
        else{
            other_values = this.required_without( value , fields )
        }
        return other_values
        
    }

    date(value) {
        if(value === 'Invalid date') {
            return false
        }

        let date = moment(value)

        return date instanceof Date && !isNaN(date.valueOf())
    }

    email(value) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return this.is_empty(value) || re.test(String(value).toLowerCase())
    }

    greater_than(value, field) {
        value = parseFloat(value)

        return this.is_empty(value) || value > parseFloat(this.data[field])
    }

    greater_than_or_equal_to(value, field) {
        value = parseFloat(value)

        return this.is_empty(value) || value >= parseFloat(this.data[field])
    }

    lesser_than(value, field) {
        value = parseFloat(value)

        return this.is_empty(value) || value < parseFloat(this.data[field])
    }

    lesser_than_or_equal_to(value, field) {
        value = parseFloat(value)

        return this.is_empty(value) || value <= parseFloat(this.data[field])
    }

    min(value, limit) {
        limit = parseFloat(limit)

        if(Array.isArray(value) || (typeof value === 'string' && Number.isNaN(parseFloat(value)))) {
            return this.is_empty(value) || value.length >= limit
        }

        return this.is_empty(value) || Number.isNaN(value) || parseFloat(value) >= limit
    }

    max(value, limit, extra) {
        limit = parseFloat(limit)

        if (typeof value === 'string') {
            let text = (extra === 'html') ? value.replace(/<[^>]*>/g, "") : value

            return text.length <= limit
        }

        if(Array.isArray(value) || (typeof value === 'string' && Number.isNaN(parseFloat(value)))) {
            return this.is_empty(value) || value.length <= limit
        }

        return this.is_empty(value) || Number.isNaN(value) || parseFloat(value) <= limit
    }

    number(value) {
        return this.numeric(value)
    }

    numeric(value) {
        return this.is_empty(value) || ! Number.isNaN(parseFloat(value)) || typeof value === 'number'
    }

    same_as(value, field) {
        return this.is_empty(value) || value === this.data[field]
    }

    different_from(value, field) {
        return this.is_empty(value) || value !== this.data[field]
    }

    is_empty(value) {
        return typeof value === 'undefined' || value === null || value === ''
    }
}
